import React from "react";
import OIEverBest from "./OIEverBest";
const OIEverBestMaster = () => {
  const head = [
    "RECEIPT_RKS",
    // "DESP_RKS",
    // "TOTAL_RKS",
    "LD_RECEIPT",
    "DWB",
    "NTKMS",
    "WKMS",
    "WTR",
    // "DSL_KM",
    // "AC_KM",
    // "TOTAL_KM",
    // "EMPTY_W_KM",
    // "LOADED_W_KM",
    // "DSL_USG",
    // "AC_USG",
    // "SPEED",
    // "SPEED_INCLU_STB",
    // "PUN_MAIL",
    // "PUN_PASS",
    // "UNLDG_WGN",
    // "LDG_WGN",
    // "LDG_MT",
    // "EARN_CRORES",
    // "MEXP_RPT",
    // "PASS_RPT",
    // "TOD_RPT",
  ];
  return (
    <div className="">
      <div className="row">
        {head.map((o, i) => (
          <div key={i} className="  col-md-2">
            <OIEverBest defCode={o} title={"loading (in MT)"} />
          </div>
        ))}
      </div>
      {/* <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"LDG_MT"} title={"loading (in MT)"} />
        </div>
      </div>
      <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"LDG_WGN"} title={"Loading wagon"} />
        </div>
      </div>
      <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"DWB"} title={"Divisional wagon balance"} />
        </div>
      </div>{" "}
      <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"WTR"} title={"Divisional wagon balance"} />
        </div>
      </div>{" "}
      <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"NTKMS"} title={"Divisional wagon balance"} />
        </div>
      </div>{" "}
      <div className="col-md-2">
        <div
          className="newUiBody"
          style={{ background: "rgba(255, 255, 255, 0.5)" }}
        >
          <OIEverBest defCode={"WKMS"} title={"Divisional wagon balance"} />
        </div>
      </div> */}
    </div>
  );
};
export default OIEverBestMaster;
